// extracted by mini-css-extract-plugin
export var dialog_modal = "modal-module--dialog_modal--4d9b1";
export var modal_body = "modal-module--modal_body--c2df5";
export var modal_close = "modal-module--modal_close--ba6db";
export var modal_header = "modal-module--modal_header--082b9";
export var modal_wrapper = "modal-module--modal_wrapper--0067c";